import { render, staticRenderFns } from "./event_submit.vue?vue&type=template&id=9c46e264&"
import script from "./event_submit.vue?vue&type=script&lang=js&"
export * from "./event_submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports